<div id="gallery-nav">
  <ul id="gallery-thumbnails">
    {{#each thumbnails}}
    <li>
      <img class="lazy" src="{{src}}" data-original="{{original}}" />
    </li>
    {{/each}}
  </ul>
</div>
